import styled from 'styled-components';
import { rgba } from 'polished';

import { c14142E, cFFFFFF } from '#/colors';
import { logException } from '#/features/logging/logging';
import { useDepositFormView } from '#/features/deposit/form-context';
import { useDepositActions } from '#/features/deposit/deposit-context';
import { useSystemConfig } from '#/features/system/system-config-context';
import { useTranslation } from '#/features/localization/utils';

import ButtonBase from './Button';

export default function BridgeEnableToken() {
  const formView = useDepositFormView();
  const depositActions = useDepositActions();
  const config = useSystemConfig();
  const { t } = useTranslation();

  const token = config.getToken(formView.asset.symbol);

  const handleRequestAllowance = () => {
    (async () => {
      await depositActions.increaseEthereumBridgeAllowance(token);
    })().catch((err) => {
      const message = 'Unexpected Error in handleRequestAllowance';
      logException(new Error(message, { cause: err }));
    });
  };

  return (
    <Content>
      <Heading>{t('Enable USDC on Paradex')}</Heading>
      {t(
        'In order to deposit you must allow Paradex access to at least {{amount}}.',
        { amount: formView.amount.formattedValue },
      )}
      <Button
        onClick={handleRequestAllowance}
        disabled={formView.isBusy}
        type="button"
      >
        {t('Enable USDC')}
      </Button>
    </Content>
  );
}

const Content = styled.div`
  background-color: ${c14142E};
  border-radius: 11px;
  color: ${rgba(cFFFFFF, 0.5)};
  display: grid;
  gap: 8px;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  padding: 12px;
`;

const Heading = styled.h2`
  color: ${cFFFFFF};
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
  margin: 0px;
`;

const Button = styled(ButtonBase)`
  height: 32px;
`;
